<template>
    <div class="animated fadeIn">
        <b-card>
            <template v-slot:header>
                <h5>Buku Besar</h5>
            </template>
            <b-form @submit.prevent="confirmPDF">
                <div class="form-content-wrapper">
                    <b-form-group label="Cabang">
                        <b-form-checkbox 
                            v-model="input.allCabang"
                            name="allCabang"
                            class="mb-2"
                            >
                            Semua Cabang
                        </b-form-checkbox>
                        <div class="mr-2">
                            <multiselect
                                name="cabang"
                                :disabled="input.allCabang"
                                v-model="input.cabang" 
                                :options="cabangOption" 
                                :internal-search="true"
                                :allow-empty="true"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="-- Pilih Cabang --"
                            />
                        </div>
                    </b-form-group>
                    <b-form-group class="small-input-date">
                        <b-form-radio v-model="dateType" value="harian">
                            <span>Harian</span>
                            <b-form-input v-model="input.tanggal" name="tanggal" type="date" :min="minDate" :max="maxDate"></b-form-input>
                        </b-form-radio>
                    </b-form-group>

                    <div v-if="input.allCabang == false">
                    <b-form-group v-if="this.fullAccess != 1 " class="small-input-date">
                        <b-form-radio v-model="dateType" value="bulanan">
                            <span>Bulanan</span>
                            <b-form-select v-model="input.bulan" id="inputBulan" name="inputBulan" :options="optionBulan" value-field="id" text-field="name">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Bulan</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-radio>
                    </b-form-group>
                    <b-form-group  v-else class="small-select-date">
                        <b-form-radio v-model="dateType" value="bulanan">
                            <span>Bulanan</span>
                            <div class="d-flex">
                                <b-form-select class="mr-2 mb-2" v-model="input.bulan" id="inputBulan" name="inputBulan" :options="bulan" value-field="id" text-field="name">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>Bulan</b-form-select-option>
                                    </template>
                                </b-form-select>
                                <b-form-select v-model="input.tahun" id="inputTahun" name="inputTahun" :options="optionTahun">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>Tahun</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </div>
                        </b-form-radio>
                    </b-form-group>
                    </div>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button v-if="input.allCabang == false"  type="submit" name="submitLaporan" variant="pgiBtn">Cetak</b-button>
                    <b-button class="ml-2" variant="success" @click="confirmExcel">Download Excel</b-button>
                </div>
            </b-form>

            <div v-if="urlLaporan != null">
                <p class="smallText text-muted">Bila laporan tidak muncul setelah lebih dari 30 detik / hanya menampilkan warna abu-abu dengan error, klik 
                    <a :href="urlLaporan" target="_blank">link</a> ini, atau hubungi HO.
                </p>
                <iframe width="100%" height="1000" :src= urlLaporan frameborder="0" allowfullscreen></iframe>
            </div>
        </b-card>
        <ModalConfirm id="modal-confirm-cetak" title="Confirm Cetak Laporan Buku Besar" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mencetak laporan buku besar ini?" @submit="printPDF" />
        <ModalConfirm id="modal-confirm-excel" title="Confirm Download Laporan Buku Besar" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk download excel laporan buku besar ini?" @submit="printExcel" />
        <b-modal id="modal-download-excel" centered title="Download Excel" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="isLoading == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="filePathDownload" download>
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'buku-besar',
    data(){
        return{
            isSubmitting: false,
            cabang: null,
            fullAccess: null,
            input: {
                cabang: null,
                tanggal: null,
                bulan: null,
                tahun: null,
                allCabang: false
            },
            cabangOption: [],
            optionBulan: [],
            optionTahun: [],
            bulan: [
                { id: "1", name: "Januari" },
                { id: "2", name: "Februari" },
                { id: "3", name: "Maret" },
                { id: "4", name: "April" },
                { id: "5", name: "Mei" },
                { id: "6", name: "Juni" },
                { id: "7", name: "Juli" },
                { id: "8", name: "Agustus" },
                { id: "9", name: "September" },
                { id: "10", name: "Oktober" },
                { id: "11", name: "November" },
                { id: "12", name: "Desember" }
            ],
            dateType: "harian",
            urlLaporan: null,
            minDate: null,
            maxDate: null,

            isLoading: false,
            filePathDownload: "",
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.cabangOption = this.$helper.getAllCabang()

            this.$axios.get('laporan/durasi-laporan').then(response => {
                this.fullAccess = response.data.id
                
                let date = new Date().toISOString().slice(0,10)
                this.input.tanggal = date
                
                // Harian

                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth()+1; //January is 0!
                var yyyy = today.getFullYear();
                if(dd<10){
                        dd='0'+dd
                    } 
                    if(mm<10){
                        mm='0'+mm
                    } 

                today = yyyy+'-'+mm+'-'+dd;
                this.maxDate = today

                if (this.fullAccess != 1){
                    var threeDaysAgo = new Date()
                    threeDaysAgo.setDate(threeDaysAgo.getDate() - 3)
                    var dd = threeDaysAgo.getDate()
                    var mm = threeDaysAgo.getMonth()+1
                    var yyyy = threeDaysAgo.getFullYear()
                    if(dd<10){
                        dd='0'+dd
                    } 
                    if(mm<10){
                        mm='0'+mm
                    } 

                    threeDaysAgo = yyyy+'-'+mm+'-'+dd;
                    this.minDate = threeDaysAgo
                }


                // Bulanan

                var months = ["Januari", "Februari", "Maret", "April", 
                                "Mei", "Juni", "Juli", "Agustus", 
                                "September", "Oktober", "November", "Desember"]
                
                if (this.fullAccess != 1){
                    var d = new Date()
                    var thisMonth = d.getMonth()
                    var thisYear = d.getFullYear()

                    var lastMonth = d.getMonth() - 1
                    if(lastMonth < 0){
                    lastMonth += 12
                        d.setYear(d.getYear() - 1)
                        var lastYear = d.getFullYear()
                    } else {
                        var lastYear = thisYear
                    }

                    this.optionBulan = [
                        { id: thisMonth+"-"+thisYear, name:months[thisMonth]+" "+thisYear },
                        { id: lastMonth+"-"+lastYear, name:months[lastMonth]+" "+lastYear }
                    ]
                } else {
					var thisYear = new Date().getFullYear()
                    for(var i = 2019; i <= thisYear; i++) {
                        this.optionTahun.push(i)
                    }
                }
            })
        },

        //----------------- Fungsi Submit Data -----------------
        confirmExcel() {

            if(!this.checkIfValidInput()) {
                this.$helper.toastErr(this, "Mohon lengkapi data untuk cetak laporan!")
                return
            }

            this.$bvModal.show("modal-confirm-excel")

        },

        printExcel() {

            this.$bvModal.hide("modal-confirm-excel")
            this.isLoading = true
            this.$bvModal.show("modal-download-excel")
            
            this.getPathToPrintables("excel").then(response => {
                this.filePathDownload = this.$baseFilePath + response.data
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => this.isLoading = false)

        },

        confirmPDF() {

            if(!this.checkIfValidInput()) {
                this.$helper.toastErr(this, "Mohon lengkapi data untuk cetak laporan!")
                return
            }

            this.$bvModal.show("modal-confirm-cetak")

        },

        printPDF() {
        
            this.isSubmitting = true

            this.getPathToPrintables("pdf").then(response => {

                this.urlLaporan = this.$baseFilePath + response.data
                this.$bvModal.hide("modal-confirm-cetak")
                this.$helper.toastSucc(this, `Laporan buku besar berhasil dibuat!`)

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => this.isSubmitting = false)

        },

        getPathToPrintables(format) {
            let cabang = `${this.input.allCabang ? "allCabang=1" : "cabangId="+ this.input.cabang.id}`
            let url = "laporan/buku-besar/?"+ cabang
            if(this.dateType == 'harian') {
                url += "&startDate=" + this.input.tanggal + "&endDate=" + this.input.tanggal
            }
            else {
                url += "&month=" + this.input.bulan + "&year=" + this.input.tahun
            }

            if(format == "excel") {
                url += "&format=excel"
            }

            return this.$axios.get(url)

        },

        //----------------- Fungsi Lain -----------------

        checkIfValidInput() {
            if(this.input.allCabang) {
                if(this.dateType == 'harian' && !this.$helper.isNotNullAndNotEmpty(this.input.tanggal)){
                    return false
                }else{
                    return true
                }
                
            }
            else  {
                if((this.input.cabang == null ||
                    this.dateType == 'harian' && !this.$helper.isNotNullAndNotEmpty(this.input.tanggal) || 
                    this.dateType == 'bulanan' && this.input.bulan == null ||
                    this.dateType == 'bulanan' && this.input.tahun == null)){
                        return false
                    }else{
                    return true
                    }
            } 


        }
    },
    watch: {
        'input.allCabang': function (newVal){
            if(newVal == true) {
                this.input.cabang = null
                this.dateType = "harian"
            }
        }
    },

    created(){
        this.init()
    }
}
</script>
